PJQ.helpers.mobile = {
	getDevice: function () {
		let userAgent = window.navigator.userAgent,
			device = null;
		if (userAgent.match(/android/i) != null) {
			device = "android";
		}
		else if (userAgent.match(/iPhone/i) != null
			|| userAgent.match(/iPod/i) != null
			|| userAgent.match(/iPad/i) != null) {
			device = "ios";
		}
		return device;
	}
};

PJQ.views.mobile = {};

PJQ.views.mobile.AppDownloadModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-App-Download'),
		cookie: 'PANTERA_APP_DOWNLOAD',
		isVerticalCenter: true
	},
	events: {
		'click .open-in-app': 'openInApp',
		'click .no-thanks': 'setCookie'
	},
	beforeModalCreated: function () {
		if (PJQ.helpers.cookieHelpers.getCookie(this.options.cookie) != null) {
			return false;
		}
	},
	openInApp: function () {
		this.setCookie();
		PJQ.app.session.project.openInApp();
	},
	setCookie: function () {
		PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true, 3);
	}
});